import { render, staticRenderFns } from "./TaskListPagination.vue?vue&type=template&id=cb2cbc92&"
import script from "./TaskListPagination.vue?vue&type=script&lang=js&"
export * from "./TaskListPagination.vue?vue&type=script&lang=js&"
import style0 from "./TaskListPagination.vue?vue&type=style&index=0&id=cb2cbc92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports